import { Alert, Button, ButtonProps, Card, Chip, styled, Typography } from '@healthinal/ui';
import { useAtom } from 'jotai';
import { useState } from 'react';
import HeurekaHealthLogo from '../assets/heureka/logo/logo.svg?react';
import { selectedOrganizationAtom } from '../state/selectedOrganization';
import { DisconnectHeurekaDialog } from './DisconnectHeurekaDialog';

const SettingsLogo = styled(HeurekaHealthLogo)`
  height: 4rem;
  width: 4rem;
`;

const HeurekaConnectCard = styled(Card)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 24px;
  align-items: center;
`;

const Status = styled('div')`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
`;

export function ConnectHeurekaHealth() {
  const [selectedOrganization] = useAtom(selectedOrganizationAtom);
  const isConnected = selectedOrganization.isConnectedToHeureka;
  const [showDisconnectDialog, setShowDisconnectDialog] = useState(false);

  return (
    <>
      <Typography level={'h3'}>Praxisanbindung</Typography>
      <HeurekaConnectCard variant={'plain'}>
        <SettingsLogo />
        {isConnected ? (
          <>
            <Status>
              <Typography level={'title-md'} fontWeight={600}>
                Heureka Health
              </Typography>
              <Chip color={'success'}>Verbunden</Chip>
            </Status>

            <Button onClick={() => setShowDisconnectDialog(true)} variant="soft" color="danger">
              Verbindung trennen
            </Button>
          </>
        ) : (
          <>
            <Status>
              <Typography level={'title-md'} fontWeight={600}>
                Heureka Health
              </Typography>
              <Chip color={'danger'}>Nicht verbunden</Chip>
            </Status>
            <HeurekaConnectButton variant="soft" color="success" />
          </>
        )}
      </HeurekaConnectCard>
      <DisconnectHeurekaDialog open={showDisconnectDialog} onClose={() => setShowDisconnectDialog(false)} />
    </>
  );
}

export function ConnectHeurekaHealthBanner() {
  return (
    <Alert
      color={'warning'}
      variant={'soft'}
      startDecorator={<HeurekaHealthLogo />}
      sx={{ maxHeight: '36px' }}
      endDecorator={
        <HeurekaConnectButton
          sx={() => ({
            '--variant-plainHoverBg': 'transparent',
            '--variant-plainActiveBg': 'transparent',
          })}
          variant="plain"
          color="warning">
          Jetzt verbinden
        </HeurekaConnectButton>
      }>
      Heureka Health ist nicht verbunden
    </Alert>
  );
}

export function HeurekaConnectButton(buttonProps: ButtonProps) {
  const [selectedPractice] = useAtom(selectedOrganizationAtom);
  return (
    <Button component="a" href={`/api/suite/heureka/practices/${selectedPractice.id}/connect`} {...buttonProps}>
      Jetzt verbinden
    </Button>
  );
}
